/**
 * Утилиты для работы с документами (PDF файлы)
 */

export interface DocumentInfo {
  id: string;
  filename: string;
  name: string;
  available: boolean;
}

/**
 * Проверяет доступность PDF документа для товара
 */
export const checkDocumentAvailability = async (productId: string): Promise<boolean> => {
  try {
    const filename = getDocumentFilename(productId);
    const response = await fetch(`/assets/documents/${filename}`, { method: 'HEAD' });
    return response.ok;
  } catch (error) {
    console.warn(`Document check failed for product ${productId}:`, error);
    return false;
  }
};

/**
 * Генерирует имя файла для товара
 */
export const getDocumentFilename = (productId: string): string => {
  const filenameMap: Record<string, string> = {
    '1': 'product-1-zoogumus.pdf',
    '2': 'product-2-prikormka-ryba.pdf',
    '3': 'product-3-dobavka-domashnie.pdf',
    '4': 'product-4-dobavka-selhoz.pdf',
    '5': 'product-5-bady.pdf'
  };
  
  return filenameMap[productId] || `product-${productId}.pdf`;
};

/**
 * Скачивает PDF документ для товара
 */
export const downloadDocument = async (productId: string): Promise<void> => {
  try {
    const filename = getDocumentFilename(productId);
    const response = await fetch(`/assets/documents/${filename}`);
    
    if (!response.ok) {
      throw new Error('Document not found');
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(`Download failed for product ${productId}:`, error);
    throw new Error('Ошибка при скачивании документа');
  }
};

/**
 * Получает информацию о документе для товара
 */
export const getDocumentInfo = async (productId: string): Promise<DocumentInfo> => {
  const filename = getDocumentFilename(productId);
  const available = await checkDocumentAvailability(productId);
  
  return {
    id: productId,
    filename,
    name: 'Рекомендации по применению и сертификаты соответствия',
    available
  };
};
